import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { rolesAPI } from '../utils/api';
import { toast } from 'sonner';
import RolPermissionsTable from './RolPermissionsTable';

const CreateRolDialog = ({ menus, open, onClose }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    permisos: [],
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await rolesAPI.create(formData);
      toast.success('Rol creado exitosamente');
      onClose();
    } catch (error) {
      toast.error('Error al crear rol');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] p-0 gap-0 flex flex-col overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-2 shrink-0">
          <DialogTitle
            className="text-2xl font-bold text-[#2D2D2D]"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Nuevo Rol
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0">
          <div className="flex-1 overflow-y-auto px-6 py-4 space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Nombre del Rol *</Label>
                <Input
                  value={formData.nombre}
                  onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                  className="border-[#c5b8a2]"
                  placeholder="ej: Supervisor"
                  required
                  data-testid="nombre-input"
                />
              </div>
              <div>
                <Label>Descripción</Label>
                <Input
                  value={formData.descripcion}
                  onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                  className="border-[#c5b8a2]"
                  placeholder="Descripción del rol"
                />
              </div>
            </div>

            <div>
              <Label className="mb-3 block text-lg font-semibold">Permisos por Menú</Label>
              <RolPermissionsTable
                menus={menus}
                permisos={formData.permisos}
                onChange={(permisos) => setFormData((f) => ({ ...f, permisos }))}
              />
            </div>
          </div>

          <div className="shrink-0 px-6 py-4 bg-white border-t border-[#E8E8E7] flex justify-end gap-3">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={loading}
              className="bg-[#9d8272] hover:bg-[#8a7162] text-white"
              data-testid="submit-button"
            >
              {loading ? 'Creando...' : 'Crear Rol'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CreateRolDialog;
